export const DEX_NAME: Record<string, string> = {
  PANCAKESWAP_V2: 'Pancake V2',
  BSC_BI_SWAP: 'Biswap',
  APESWAP: 'Apeswap',
  APESWAP_V3: 'Apeswap V3',
  ELLIPSIS_FINANCE: 'Ellipsis',
  BSC_BABYDOGE: 'BabyDoge',
  MDEX: 'MDEX',
  BSC_DODO_V1: 'DODO',
  BSC_DODO_V2: 'DODO V2',
  DODOV3: 'DODO V3',
  BALANCERV2: 'Balancer V2',
  HASHFLOW: 'Hashflow',
  PANCAKESWAP_STABLE: 'Pancake Stable',
  VVS: 'VVS Finance',
  VVSV3: 'VVS Finance V3',
  MMF: 'MM Finance',
  MMFV3: 'MM Finance V3',
  CRODEX: 'Crodex',
  CRONASWAP: 'CronaSwap',
  CANDYCITYFINANCE: 'Candycity Finance',
  CROWFI: 'CrowFi',
  FERRO: 'Ferro',
  UNISWAP_V3: 'Uniswap V3',
  UNISWAP_V2: 'Uniswap V2',
  AERODROMESLIPSTREAM: 'Aerodrome SlipStream',
  CURVETRICRYPTO: 'Curve',
  SUSHISWAP: 'Sushiswap',
  SUSHISWAPV3: 'Sushiswap V3',
  PANCAKE_V3: 'Pancake V3',
  WOMBAT: 'Wombat',
  LEVEL: 'Level Finance',
  FULCROM: 'Fulcrom Finance',
  WOOFI: 'WOOFi',
  ECHODEXV3: 'EchoDEX V3',
  VELOCOREV2: 'Velocore V2',
  SYNAPSE: 'Synapse',

  SWAPBASED: 'SwapBased',
  SWAPBASEDV3: 'SwapBased V3',
  BASESWAP: 'BaseSwap',
  BASESWAPV3: 'BaseSwap V3',
  CLOUDBASE: 'CloudBase',
  SYNTHSWAP: 'Synthswap',
  SYNTHSWAPV3: 'Synthswap V3',
  DACKIESWAP: 'DackieSwap',
  ZEBRAV2: 'Zebra V2',

  'ALIEN-BASE': 'Alien Base',
  'BAKERYSWAP-BASE': 'BakerySwap',
  'ICECREAMSWAP-BASE': 'Icecreamswap',

  'LFGSWAP-BASE': 'LFGSwap',
  'UNISWAP-V3-BASE': 'Uniswap V3',
  'SUSHISWAP-V3-BASE': 'Sushiswap V3',
  'CRESCENTSWAP-BASE': 'CrescentSwap',
  'YUM-YUM-SWAP': 'Yum Yum Swap',

  'PANCAKESWAP-V3-LINEA': 'Pancake V3',
  LYNEX: 'Lynex',
  LYNEXV2: 'Lynex V2',
  'KYBERSWAP-ELASTIC': 'KyberSwap',
  HORIZON: 'Horizon',
  SYNCSWAP: 'SyncSwap',
  VOOI: 'VOOI',
  'THENA-FUSION': 'Thena Fusion',
  SADDLE: 'Saddle Finance',
  PAPYRUSSWAP: 'Papyrus Swap',
  SPACESWAP: 'SpaceSwap',
  SPACEFI: 'SpaceFi',
  METAVAULTV3: 'MetaVault V3',
  IZISWAP: 'iZUMi.Finance',
  ZEBRA: 'Zebra',
  SKYDROME: 'Skydrome',
  SOSWAP: 'Soswap',
  SHARKSWAP: 'SharkSwap',
  AERODROME: 'Aerodrome',
  CURVE: 'Curve',
  QUICKSWAPV3: 'Quickswap V3',
  QUICKSWAPV3POLYGON: 'Quickswap V3',
  APERTURESWAP: 'ApertureSwap',
  PACIFICSWAP: 'PacificSwap',
  MAVERICKV1: 'Maverick V1',
  MAVERICKV2: 'Maverick V2',
  THRUSTERV3: 'Thruster V3',
  THRUSTERV2_03: 'Thruster V2',
  THRUSTERV2_10: 'Thruster V2',
  HYPERBLAST: 'HyperBlast',
  DYORSWAP: 'DyorSwap',
  MONOSWAPV3: 'MonoSwap V3',
  CYBERBLASTV3: 'CyberBlast V3',
  BLASTERSWAPV2: 'BlasterSwap',
  BITDEX: 'BitDex',
  NILE: 'Nile',
  NILEV1: 'Nile V1',
  ROGUEX: 'RogueX',
  KELLERCL: 'Keller CL',
  KELLERV2: 'Keller V2',
  HERCULESV2: 'Hercules V2',
  HERCULESV3: 'Hercules V3',
  HERMES: 'Hermes Protocol',
  WAGMI: 'Wagmi',
  TETHYS: 'Tethys',
  NETSWAP: 'NetSwap',
  WMETIS: 'Wrapped Metis',
  OKUTRADE: 'Oku Trade',
  ABSTRADEX: 'Abstradex',
  REVOSWAPV2: 'RevoSwap V2',
  REVOSWAPV3: 'RevoSwap V3',
  POTATOSWAP: 'PotatoSwap',
  XLAYERSWAP: 'XLayerSwap',
  STATIONDEXV3: 'StationDEX V3',
  LINEHUBV3: 'Line Hub V3',
  SECTAFINANCEV3: 'Secta Finance V3',
  SECTAFINANCEV2: 'Secta Finance V2',
  NURI: 'Nuri',
  CAMELOT: 'Camelot',
  CAMELOTV3: 'Camelot V3',
  SPARTADEX: 'SpartaDEX',
  RAMSES: 'Ramses',
  RAMSESV2: 'Ramses V2',
  GULLNETWORK: 'Gull Network',
  FIREFLY: 'Firefly',
  TRADERJOEV2_1: 'Trader Joe V2.1',
  BLASTERSWAPV3: 'BlasterSwap V3',
  EDDYFINANCE: 'EddyFinance',
  BLADESWAP: 'Bladeswap',
  FENIXFINANCE: 'Fenix Finance',
  QUICKSWAP: 'Quickswap',
  RETRO: 'Retro',
  SWAAPV2: 'Swaap V2',
  KYOFINANCEV3: 'Kyo Finance V3',
  KYOFINANCEV2: 'Kyo Finance V2',
  SONEX: 'Sonex',
  SONEFI: 'SoneFi',
  SWOPFI: 'Swopfi',
  SONUS: 'Sonus',
  SONUSV2: 'Sonus V2',
  'VELODROME-SLIPSTREAM': 'Velodrome SlipStream',
  HYPERSWAPV3: 'HyperSwap V3',
  HYBRAFINANCEV3: 'Hybra Finance V3',
  KITTENSWAPV3: 'Kittenswap V3',
  PROJECTX: 'Project X',
  RAMSESV3: 'Ramses V3',
  KOALASWAP: 'KoalaSwap',
  ETHEREX_LEGACY: 'Etherex Legacy',
  ETHEREX: 'Etherex',

  UNISWAPV4: 'Uniswap V4',
  PANCAKEINFINITY: 'Pancake Infinity CLMM',
  RINGEXCHANGE: 'Ring Exchange',
  FLUIDT1: 'Fluid T1',
  FLUIDLITE: 'Fluid Lite',
  VELODROMESLIPSTREAM: 'Velodrome SlipStream',
};
